
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Update, GetById, GetAllDepartments } from "adminApi/UserManageApi/Division";
import Spinner from "Common/Globle/Spinner";
import EditDivisionForm from "./components/EditDivisionForm";
import fields from "../json/Division.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchFormDataById from "Hooks/useFetchFormDataById";
import { DivisionRules } from "validation/ValidationRules";
import { validateForm } from "utils/validation";
import useFetchAllData from "Hooks/useFetchAllData"


const EditDivision = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const { formdata } = fields;

    // Initialize form values
    const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

    const { values, errors, handleChange, setErrors, setValues } = useFormChange(
        initialValues,
        DivisionRules
    );

    // Fetch departments for dropdown
    const { data: departments, loading: loadingDepartments } = useFetchAllData(GetAllDepartments);

    // Fetch existing data
    const { loading: loadingFetch } = useFetchFormDataById(
        id,
        formdata,
        GetById,
        setValues
    );

    // Form submit
    const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
        async (formValues) => {
            return await Update({ id, data: formValues });
        },
        (vals) => {
            const err = validateForm(vals, DivisionRules)
            setErrors(err);
            return err;
        },
        () => navigate(-1),
        "Division updated successfully"
    );

    return (
        <>
            {(loadingSubmit || loadingFetch || loadingDepartments) && <Spinner isSpinner={true} />}
            <EditDivisionForm
                fields={formdata}
                values={values}
                errors={errors}
                departments={departments}
                handleChange={handleChange}
                handleSubmit={(e) => handleSubmit(e, values)}
                loading={loadingSubmit}
                title="Edit Division"
            />
        </>
    );
};

export default EditDivision;
